import {BehaviorSubject} from 'rxjs'
import store from '../store'
import Vue from 'vue'
import {getRoles} from './roles_admin'
import {Role} from "@/js/roles";

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')))

export const authentication = {
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value
  }
}

// TODO habilitar para desarrollo
/*function login(account, password) {
  try {
    let obj = {}
    obj = {
      "fn": "login_ex",
      "v": 1,
      "id": 3,
      "status": 1,
      "s": "71336012b07f4134e6478dc5a69e33e7",
      "user": {
        "id": 12,
        "user_account": "jperez",
        "first_name": "Juan Alejandro",
        "last_name": "Perez Chandia",
        "ts_creation": "2021-06-18T03:31:52.000000Z",
        "status": 1,
        "email": "jalejandro.ingeniero@gmail.com",
        "ts_last_update": "2022-10-17T22:00:12.749167Z",
        "phone": "999380122",
        "ts_password_last_update": "2022-10-17T22:00:12.749167Z",
        "config": {
          "redirect": "/propiedades",
          "auto_save": 0,
          "dark_mode": 0,
          "hidden_menu": 0,
          "special_day": 1
        },
        "photo": "jperez.jpg",
        "avatar": "avatar_1.png",
        "roles": [
          "developer"
        ]
      },
      "tareas_hoy_y_vencidas": [],
      "estadisticas": null,
      "notificaciones": null
    }
    localStorage.setItem('currentUser', JSON.stringify(obj.user))
    localStorage.setItem('task', JSON.stringify(obj.tareas_hoy_y_vencidas))
    localStorage.setItem('cant_task', obj.tareas_hoy_y_vencidas.length)
    Vue.prototype.$task.task = obj.tareas_hoy_y_vencidas
    Vue.prototype.$task.cant = obj.tareas_hoy_y_vencidas.length

    if(obj.user.config['special_day'] !== undefined){
      Vue.prototype.$user.special_day = obj.user.config['special_day'] === 1
      store.commit('changeSpecialDay', obj.user.config['special_day'] === 1);
    } else {
      obj.user.config['special_day'] = true
    }

    if (obj.user.config['hidden_menu'] !== undefined) {
      Vue.prototype.$user.hidden_menu = obj.user.config['hidden_menu'] === 1
      store.commit('changeHiddenMenu', obj.user.config['hidden_menu'] === 1)
    } else {
      obj.user.config['hidden_menu'] = true
    }
    if (obj.user.config['theme_mixed'] !== undefined) {
      Vue.prototype.$user.theme_mixed = obj.user.config['theme_mixed'] === 1
      store.commit('changeThemeMixed', obj.user.config['theme_mixed'] === 1)
    } else {
      obj.user.config['theme_mixed'] = false
    }

    if (obj.user.avatar !== null && obj.user.avatar !== undefined) {
      obj.user.avatar = obj.user.avatar.replace(".png", "")
      if (Vue.prototype.$user.avatar_list.includes(obj.user.avatar)) {
        Vue.prototype.$user.avatar = true
        Vue.prototype.$user.src_avatar = obj.user.avatar
        console.log("autenticator", Vue.prototype.$user.src_avatar)
      } else {
        Vue.prototype.$user.avatar = false
      }
    } else {
      Vue.prototype.$user.avatar = false
    }
    currentUserSubject.next(obj.user)
    return true
  } catch (e) {
    console.error(e)
    return false
  }
}*/

// TODO habilitar para produccion
async function login(account, password) {
  try {
    const obj = await store.state.ioh.login_ex(account, password)
    if (obj.status === store.state.ioh.STATUS_OK) {
      localStorage.setItem('currentUser', JSON.stringify(obj.user))
      localStorage.setItem('task', JSON.stringify(obj.tareas_hoy_y_vencidas))
      localStorage.setItem('cant_task', obj.tareas_hoy_y_vencidas.length)
      Vue.prototype.$task.task = obj.tareas_hoy_y_vencidas
      Vue.prototype.$task.cant = obj.tareas_hoy_y_vencidas.length

      if (obj.user.roles.includes(Role.ejecutivo)) {
        await getPropiedadesByEjecutivo(obj.user.id)
      } else {
        await getPropiedades()
      }

      if (obj.user.config['special_day'] !== undefined) {
        Vue.prototype.$user.special_day = obj.user.config['special_day'] === 1
        store.commit('changeSpecialDay', obj.user.config['special_day'] === 1);
      } else {
        obj.user.config['special_day'] = true
      }

      if (obj.user.config['hidden_menu'] !== undefined) {
        Vue.prototype.$user.hidden_menu = obj.user.config['hidden_menu'] === 1
        store.commit('changeHiddenMenu', obj.user.config['hidden_menu'] === 1)
      } else {
        obj.user.config['hidden_menu'] = true
      }
      if (obj.user.config['theme_mixed'] !== undefined) {
        Vue.prototype.$user.theme_mixed = obj.user.config['theme_mixed'] === 1
        store.commit('changeThemeMixed', obj.user.config['theme_mixed'] === 1)
      } else {
        obj.user.config['theme_mixed'] = false
      }

      // TESTING GET ROLES
      let temp = await getRoles()
      // console.log("getRoles() - Login:", temp)

      if (obj.user.avatar !== null && obj.user.avatar !== undefined) {
        if (Vue.prototype.$user.avatar_list.includes(obj.user.avatar)) {
          Vue.prototype.$user.avatar = true
          Vue.prototype.$user.src_avatar = obj.user.avatar
        } else {
          Vue.prototype.$user.avatar = false
        }
      } else {
        Vue.prototype.$user.avatar = false
      }
      currentUserSubject.next(obj.user)
      return true
    } else {
      console.log('Usuario o Contraseña incorrecta!')
      return false
    }
  } catch (e) {
    console.error(e)
    return false
  }
}

async function getPropiedades() {
  try {
    const obj = await store.state.ioh.get_propiedades(true)
    if (obj.status === store.state.ioh.STATUS_OK) {
      Vue.prototype.$srcPropiedades.data = obj.propiedades
    } else {
      console.warn(obj.reason)
      return false
    }
  } catch (ex) {
    console.error(ex)
    return false
  }
}

async function getPropiedadesByEjecutivo(id) {
  try {
    const obj = await store.state.ioh.get_propiedades_by_ejecutivo(id)
    if (obj.status === store.state.ioh.STATUS_OK) {
      Vue.prototype.$srcPropiedades.data = obj.propiedades
    } else {
      console.warn(obj.reason)
      return false
    }
  } catch (ex) {
    console.error(ex)
    return false
  }
}

function logout() {
  Vue.prototype.$srcPropiedades.data = []
  Vue.prototype.$page.number = 1
  Vue.prototype.$taskAlert.alert = true
  Vue.prototype.$task.task = []
  Vue.prototype.$task.cant = 0
  Vue.prototype.$user.special_day = true
  Vue.prototype.$user.hidden_menu = true
  Vue.prototype.$user.avatar = false
  Vue.prototype.$user.src_avatar = ''
  localStorage.removeItem('avatar')
  localStorage.removeItem('propiedades')
  localStorage.removeItem('comunas')
  localStorage.removeItem('ejecutivos')
  localStorage.removeItem('currentUser')
  localStorage.removeItem('propertyFilter')
  localStorage.removeItem('task')
  localStorage.removeItem('cant_task')

  localStorage.clear()
  currentUserSubject.next(null)
}
